<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>
                            <i class="panel__header__icon icons icon-people"></i>
                            <span v-if="loadingProfile">{{$t("work_processes.table.loading")}}</span>
                            <span v-else>{{profile.name}}</span>
                        </h2>
                    </div>
                    <div v-if="chartLoading" class="panel__body">
                        <div class="spinner"></div>
                    </div>
                    <div v-else class="panel__body">
                        <div style="max-width: 500px; margin: auto">
                            <Radar :chartdata="chart" :options="chartOptions" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="background: #fff; overflow:hidden">
            <table class="table--sub_categories" v-if="chartOriginal">
                <thead>
                    <tr>
                        <th colspan="4">{{$t("work_processes.table.header.work_process")}}</th>
                    </tr>
                </thead>
                <tbody v-for="(ct, index) in chartOriginal" :key="`coreTask_${index}`">
                    <tr>
                        <td colspan="4">
                            {{ ct.coreTask.title }}
                        </td>
                    </tr>
                    <tr v-for="(wp, idx) in ct.coreTask.workProcesses" :key="`workProcesses_${idx}`">
                        <td class="no_border">&nbsp;</td>
                        <td>{{ wp.work_process.index }}</td>
                        <td>{{ wp.work_process.title }}</td>
                        <td class="no_border">&nbsp;</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import { GET_CHART, GET_DIPLOMA } from '@/store/modules/chart';
    import { GET_PROFILE } from '@/store/modules/profile';
    import Radar from '@/components/charts/Radar';

    @Component({
        components: {
            Radar
        }
    })
    export default class Chart extends Vue {
        name = 'chart';
        userId = 0;
        diplomaId = 0;

        get chartOriginal() {
            let chart = this.$store.state.chart.chart;
            let idx = 1;
            chart.forEach(el => {
                el.coreTask.workProcesses.map(wp => {
                    wp.work_process.index = idx;
                    idx += 1;
                });
            });
            return chart;
        }

        get chart() {
            let chart = this.$store.state.chart.chart;
            let dataset = chart.map(el => {
                return el.coreTask.workProcesses.map(wp => {
                    return wp.score;
                });
            }).flatten();
            let labels = chart.map(el => {
                return el.coreTask.workProcesses.map(wp => {
                    return wp.work_process.title;
                });
            }).flatten();
            try {
                let data = {datasets: [{data: dataset}], labels: labels};
                data.labels = data.labels.map((label, index) => index + 1);
                data.datasets[0].label = this.$t('evaluations.score');
                data.datasets[0].backgroundColor = 'rgba(115,95,194,0.5)';
                data.datasets[0].borderColor = 'rgba(115,95,194,1)';
                data.datasets[0].borderWidth = 1;
                data.datasets[0].radius = 3;
                data.datasets[0].pointBackgroundColor = 'rgba(115,95,194,1)';
                data.datasets[0].pointBorderColor = 'transparent';
                console.log(data);
                return data;
            } catch (error) {
                return { labels: [] };
            }
        }

        get chartOptions() {
            // Workaround for accessing Vue context
            let v = this;
            return {
                tooltips: { enabled: false },
                legend: { display: false },
                scale: {
                    ticks: {
                        max: 3,
                        min: 0,
                        stepSize: 1,
                        callback: function(value, index, values) {
                            if (value === 1) return v.$t('evaluations.starter');
                            if (value === 2) return v.$t('evaluations.advanced');
                            if (value === 3) return v.$t('evaluations.professional');
                        }
                    }
                }
            };
        }

        get chartLoading() {
            return this.$store.state.chart.loading;
        }

        get profile() {
            return this.$store.state.profile.profile;
        }

        get diplomaName() {
            return '';
        }

        get loadingProfile() {
            return this.$store.state.profile.loading;
        }

        mounted() {
            this.userId = this.$route.params.user_id;
            this.diplomaId = this.$route.params.diploma_id;
            this.$store.dispatch(GET_CHART, { user_id: this.userId, diploma_id: this.diplomaId });
            this.$store.dispatch(GET_PROFILE, { id: this.userId });
        }
    }

    Vue.component('chart', Chart);
</script>



// WEBPACK FOOTER //
// src/pages/Chart.vue